import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 21H14V19H21V5H3V8H1V5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21ZM12 21H10C10.005 18.6124 9.05472 16.3219 7.361 14.639C5.67821 12.9451 3.38769 11.9948 1 12V9.99996C3.91792 9.99224 6.71779 11.1516 8.776 13.22C10.847 15.2784 12.008 18.0801 12 21ZM8.00003 21H6C6.00273 19.6735 5.47487 18.401 4.534 17.466C3.59908 16.5249 2.32652 15.9971 1 16V14C2.85776 13.9944 4.64056 14.7322 5.951 16.049C7.26773 17.3595 8.00554 19.1423 8.00003 21ZM4 21H1V18C2.65685 18 4 19.3431 4 21Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Cast"
);
